import React, { useState, useContext, useEffect, useRef } from "react"

import { Link, useLocation } from "react-router-dom"

import { useHistory } from "react-router-dom"

import backBtn from "../../../../assets/images/back-arrow.svg"
import errorSVG from "../../../../assets/images/error.svg"
import deleteImg from "../../../../assets/images/delete.svg"
import plusIcon from "../../../../assets/images/plus-icon.svg"



import SimpleReactValidator from "simple-react-validator"

import TextField from "../../../../components/formFields/textField/textField"
import SingleSelect from "../../../../components/formFields/singleSelect/singleSelect"
import ConfirmAlert from "../../../../components/addon/confirmAlert"

import { objectDeepClone, compareObjs } from "../../../../service/helper"

import config from "../../../../service/config"
import AppContextObject from "../../../../common/context/common"

import { ReactInternetSpeedMeter } from 'react-internet-meter'
import ConfirmDialog from "../../../../components/addon/confirmDialog/confirmDialog"
import noImg from "../../../../assets/images/blank-inventory-img.jpg"

const ProfileGeneral = (props) => {
    const {
        events,
        progress,
        brandProfile,
        parentData,
        isBackendUser,
        setBrandProfile
    } = props

    // initialInternetSpeedTest
    const history = useHistory()
    const location = useLocation()
    const context = useContext(AppContextObject)

    const [showModalTwoMore, setShowModalTwoMore] = useState(false)
    const [overlay, setOverlay] = useState(false)
    const [showPrompt, setShowPrompt] = useState(false)
    const [oldFormData, setOldFormData] = useState<any>({})
    const [formValidator] = useState(useRef(new SimpleReactValidator({
        element: (message, className) =>
            <p className="valError"><img src={errorSVG} />{message}</p>
    })))

    const [update, forceUpdate] = useState(false)
    const [formData, setFormData] = useState<any>({})
    const [brandCategoryList, setBrandCategoryList] = useState([])
    const [pingIntervalTime, setPingIntervalTime] = useState(1000)
    const [wifiSpeed, setwifiSpeed] = useState<any>(null)
    const [toggleNetworkDialog, setToggleNetworkDialog] = useState(false)
    const [checkSpeed, setCheckSpeed] = useState(false)
    const [otherLinksError,setOtherLinksError] = useState([])
    const [showOtherLinkError, setShowOtherLinkError] = useState(false)

    useEffect(() => {
        if (events && events.setActiveModule) {
            events.setActiveModule({
                module: "general"
            })
        }
        console.log("brandProfile..", brandProfile.general)
        if (brandProfile && brandProfile.general) {
            setFormData(objectDeepClone(brandProfile.general))
            setOldFormData(objectDeepClone(brandProfile.general))
        }
    }, [brandProfile])

    useEffect(() => {
        getBrandCategoryList()
    }, [])
 
    useEffect(() => {
        const isSame = compareObjs(formData, oldFormData)

        if (isSame === false) {
            setShowPrompt(true)
        } else {
            setShowPrompt(false)
        }
    }, [formData])

    useEffect(()=>{
        if(checkSpeed == false && location.pathname === "/brands/brand-details/profile/general" && !parentData.initialInternetSpeedTest){
            testSpeed()
        }
    },[])

    useEffect(()=>{
        if(location.pathname === "/brands/brand-details/profile/general"){
            if(wifiSpeed !== null){
                if(Number(wifiSpeed) < context.utils.internetSpeedLimit && !parentData.initialInternetSpeedTest){
                    setToggleNetworkDialog(true)
                    setOverlay(true)
                }else{
                    setToggleNetworkDialog(false)
                    setOverlay(false)
                    if(parentData.setInitialInternetSpeedTest){
                        parentData.setInitialInternetSpeedTest(true)
                    }
                }
            }
            
        }
    }, [wifiSpeed, location.pathname])

    const testSpeed = () => {
        setCheckSpeed(true)
        setTimeout(()=>{
            setPingIntervalTime(1000)
            setCheckSpeed(false)
            // setwifiSpeed(0)
        }, 2000)
    }
    const networkConfirmClose = (confirm) => {
        console.log("cofirm--->>",confirm);
        setToggleNetworkDialog(false)
        setOverlay(false)
        if(parentData.setInitialInternetSpeedTest){
            parentData.setInitialInternetSpeedTest(true)
        }
        setwifiSpeed(null)
    }

    const getBrandCategoryList = async() => {
        const resp = await context.apis.public.listBrandCategoriesMaster(
            context.validator, {}, {}
        )
        console.log("resp===",resp)
        if(resp && resp.done){
            let catData = []
            if(resp.response && resp.response.rows && resp.response.rows.length > 0)
            {
                for(let category of resp.response.rows)
                {
                    catData.push({
                        label: category.name,
                        value: category.name,
                        _id: category._id
                    })
                }
            }
            setBrandCategoryList(catData)
        }
    }


    const openModalTwoMore = () => {
        setShowModalTwoMore(true)
        setOverlay(true)
    }

    const closeWithoutSaving = () => {
        setShowModalTwoMore(false)
        setOverlay(false)
    }

    const onFormDataChange = (event) => {
        setFormData({
            ...formData,
            [event.target.id]: event.target.value
        })
    }

    const onSocialMediaChange = (event) => {
        setFormData({
            ...formData,
            socialMedia: {
                ...formData.socialMedia,
                [event.target.id]: event.target.value
            }
        })
    }

    const onCategoryChange = (data) => {
        console.log("dattaaaaaa", data)
        setFormData({
            ...formData,
            companyCategory: data._id
        })
    }

    const onSubmitClick = () => {
        // setOtherLinksError([])
        let count = 0;
        if(formData.socialMedia.other && formData.socialMedia.other.length !== 0) {
            const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;
            const arr =[]
            formData.socialMedia.other.map((item,index) => {
                if (item.trim() === "") {
                    arr[index] = "required"
                    count++
                }
                else if(regex2.test(item) === false) {
                    arr[index] = "invalid"
                    count++
                }
                else {
                    arr[index] = ""
                }
            })
            if(count > 0) {
                setOtherLinksError(arr)
            }
        }
        // if(count > 0) {
        //     return
        // }
        const result = formValidator.current.allValid()

        if (result === false || count > 0) {
            formValidator.current.showMessages()
            setShowOtherLinkError(true)
            forceUpdate(true)
            return
        } else {
            formValidator.current.hideMessages()
            setShowOtherLinkError(false)
            forceUpdate(!update)
        }
        setShowPrompt(false)

        process.nextTick(() => {
            if (events && events.setBrandProfile) {
                const json = objectDeepClone(brandProfile)
                json.general = objectDeepClone(formData)
                progress.general = true
                // events.setBrandProfile(json)
                let categoryLabel = brandCategoryList.find(el => el._id === formData.companyCategory)
                if(categoryLabel.label === "Others"){
                    events.setBrandProfile({...json, otherBrandCategory: true})
                }else{
                    events.setBrandProfile({...json, otherBrandCategory: false})
                }
                if(isBackendUser){
                    history.push("/backend/backend-details/brands/brand-details/description")
                }else{
                    history.push("/brands/brand-details/profile/description")
                }
            }
        })
    }

    const validateTwitterURL = (url) => {
        // var re = new RegExp('((http://)|(www\\.))twitter\\.com/(\\w+)')
        // var re = new RegExp('((http://)|(www\\.))twitter\\.com/(\\w+)')
        // var match = url.includes('twitter.com')
        return /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?twitter.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(url)
        // return match
    }

    const validateInstaURL = (url) => {
        return /^(?:(?:http|https):\/\/)?(?:www.)?instagram.com\/(?:(?:\w)*#!\/)?/.test(url)
    }

    const validateLinkedInURL = (url) => {
        return /(https?)?:?(\/\/)?(([w]{3}||\w\w)\.)?linkedin.com(\w+:{0,1}\w*@)?(\S+)(:([0-9])+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/.test(url)
    }

    const validateFacebookURL = (url) => {
        return /^(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.\*))?([\w.\-]*)?$/.test(url)
    }

    const confirmAlertCallback = (data) => {
        console.log('working', data);
        setOverlay(data.overlay)
        // setShowPrompt(false)
    }

    const addNewSocialLink = (keyName) => {
        console.log("working 1");
        if (keyName) {
        console.log("working 2");
            setFormData({
                ...formData,
                socialMedia: {
                    ...formData.socialMedia,
                    [keyName]: ""
                }
            })
        } else {
        console.log("working 3");
            const arr = objectDeepClone(formData.socialMedia.other || [])
            arr.push("")
            console.log("arr", arr);
            setFormData({
                ...formData,
                socialMedia: {
                    ...formData.socialMedia,
                    other: objectDeepClone(arr)
                }
            })
        }
        closeWithoutSaving()
    }
    console.log("formData======",formData);

    const onOtherMediaChange = (event, index) => {
        const arr = objectDeepClone(formData.socialMedia.other)
        arr[index] = event.target.value
        setFormData({
            ...formData,
            socialMedia: {
                ...formData.socialMedia,
                other: objectDeepClone(arr)
            }
        })
        if(showOtherLinkError){
            const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;
            let errorArray = [...otherLinksError]
            if(event.target.value === ""){
                errorArray[index] = "required"
            }
            else if(regex2.test(event.target.value) === false){
                errorArray[index] = "invalid"
            }
            else if(regex2.test(event.target.value) === true){
                errorArray[index] = ""
            }
            setOtherLinksError([...errorArray])
        }
    }

    const deleteOtherURL = (index) => {
        const arr = objectDeepClone(formData.socialMedia.other)
        arr.splice(index, 1)
        setFormData({
            ...formData,
            socialMedia: {
                ...formData.socialMedia,
                other: objectDeepClone(arr)
            }
        })
    }

    formValidator.current.rules['twitter_url'] = {
        message: 'Please enter valid twitter url.',
        rule: (val) => {
            let returnValue = validateTwitterURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['instagram_url'] = {
        message: 'Please enter valid instagram url.',
        rule: (val) => {
            let returnValue = validateInstaURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['facebook_url'] = {
        message: 'Please enter valid facebook url.',
        rule: (val) => {
            let returnValue = validateFacebookURL(val)
            return returnValue
        },
    }

    formValidator.current.rules['linkedin_url'] = {
        message: 'Please enter valid linkedIn url.',
        rule: (val) => {
            let returnValue = validateLinkedInURL(val)
            return returnValue
        },
    }

    console.log("general formData=",formData);

    formValidator.current.rules['company_name'] = {
        message: 'Please enter valid company name.',
        rule: (val) => {
            let returnValue = true
            if (!val || val.trim() === "") {
                returnValue = false
            }
            const regex2 = /[a-zA-Z]/;
            if (!regex2.test(val)) {
                returnValue = false
            }
            return returnValue
        },
    }

    formValidator.current.rules['website'] = {
        message: 'Please enter valid company website.',
        rule: (val) => {
            let returnValue = true
            if (!val || val.trim() === "") {
                returnValue = false
            }
            const regex2 = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#-]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
            if (!regex2.test(val)) {
                returnValue = false
            }

            return returnValue
        },
    }


    return (
        <>
            <div className={`ovelap ${overlay === true ? "active" : ""}`}></div>
            {
                    checkSpeed
                    &&
                    <ReactInternetSpeedMeter  
                        txtSubHeading="Internet is too slow"
                        outputType="alert"
                        customClassName={"slowInternetMsg"}
                        txtMainHeading="Opps..."
                        pingInterval={pingIntervalTime} // milliseconds
                        thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte"
                        threshold={100}
                        imageUrl={context.utils.internetSpeedTestingImg}
                        downloadSize="2550420"  //bytes
                        callbackFunctionOnNetworkDown={(speed)=>console.log(`Internet speed is down ${speed}`)}
                        callbackFunctionOnNetworkTest={(speed)=>{ console.log(`Internet Speed is ${speed} MBps`); setwifiSpeed(speed)}}
                    />
                }
            <div className="col-xl-9 col-lg-9 col-md-12 col-xs-12">
                <div className="rightPart noBack">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-xs-6">
                            <Link to={isBackendUser ? "/backend/backend-details/brand-list" : "/brands/brand-details/profile"} className="backbtn dblock">
                            <img src={backBtn} />BACK </Link>
                        </div>
                        <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mt-20">
                            <h2 className="htx5 clearfix">Tell us about your company</h2>
                        </div>
                        {
                            Object.keys(formData).length > 0 &&
                            <div className="col-xl-7 col-lg-7 col-md-10 col-xs-12 mt-40 mb-20 pl forminpt-bottom">
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <TextField
                                            formData={formData}
                                            formKey='companyName'
                                            onDataChange={onFormDataChange}
                                            label='Company Name'
                                            placeholder='Enter Company Name'
                                            isRequired={false}
                                            formValidator={formValidator}
                                            validation='required|company_name'
                                            maxLength={100}
                                        />
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <SingleSelect
                                            formData={formData}
                                            formKey='companyCategory'
                                            onDataChange={onCategoryChange}
                                            label='Company Category'
                                            placeholder='Select Company Category'
                                            isRequired={false}
                                            options={brandCategoryList}
                                            formValidator={formValidator}
                                            validation='required'
                                            matchById={true}
                                        />
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <TextField
                                            formData={formData}
                                            formKey='companyWebsite'
                                            onDataChange={onFormDataChange}
                                            label='Website URL'
                                            placeholder='Enter Website URL'
                                            isRequired={false}
                                            formValidator={formValidator}
                                            validation='required|website'
                                        />
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mt-20 mb-20">
                                        <h2 className="htx2 clearfix">Social Media Links</h2>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-20">
                                        <div className="social-general">
                                            <span>
                                                <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20.9691 1L21.7174 0.948932C21.697 0.65034 21.5011 0.392447 21.2189 0.292796C20.9366 0.193144 20.6222 0.270812 20.4189 0.4904L20.9691 1ZM20.2928 5.10624C20.2928 4.69202 19.957 4.35623 19.5428 4.35623C19.1286 4.35623 18.7928 4.69202 18.7928 5.10624H20.2928ZM11 6.34286V7.09286H11.75V6.34286H11ZM2.42637 1L3.12618 0.730267C3.01989 0.454488 2.76154 0.266849 2.46641 0.25107C2.17127 0.23529 1.89439 0.394313 1.7593 0.657186L2.42637 1ZM8 13.6286L8.52301 14.1661C8.7114 13.9828 8.79009 13.7143 8.73041 13.4583C8.67073 13.2023 8.4814 12.9962 8.23137 12.9152L8 13.6286ZM1 16.2653V15.5153C0.667752 15.5153 0.375101 15.7339 0.280826 16.0525C0.186551 16.3711 0.313122 16.7137 0.591869 16.8945L1 16.2653ZM18.4515 2.35081L17.9025 2.86181L18.1709 3.15017L18.5607 3.09283L18.4515 2.35081ZM20.2209 1.05107C20.2943 2.12631 20.2255 2.76935 20.0505 3.24863C19.8808 3.71326 19.5835 4.10066 19.0318 4.6143L20.0538 5.71223C20.6807 5.1287 21.1726 4.54874 21.4595 3.76316C21.741 2.99224 21.7961 2.10222 21.7174 0.948932L20.2209 1.05107ZM20.2928 6.11734V5.16327H18.7928V6.11734H20.2928ZM20.2928 5.16327V5.10624H18.7928V5.16327H20.2928ZM10.25 5.37143V6.34286H11.75V5.37143H10.25ZM15.3223 0.25C12.4943 0.25 10.25 2.64475 10.25 5.37143H11.75C11.75 3.4365 13.3589 1.75 15.3223 1.75V0.25ZM18.7928 6.11734C18.7928 12.0684 13.6398 17.25 7.5 17.25V18.75C14.4567 18.75 20.2928 12.9083 20.2928 6.11734H18.7928ZM1.72655 1.26973C2.52294 3.33594 5.48299 7.09286 11 7.09286V5.59286C6.24717 5.59286 3.75616 2.36474 3.12618 0.730267L1.72655 1.26973ZM1.7593 0.657186C0.259127 3.57631 -0.0106888 6.45179 1.04745 8.91167C2.10404 11.3679 4.41833 13.2555 7.76863 14.342L8.23137 12.9152C5.16302 11.9201 3.26412 10.2688 2.42538 8.31894C1.58818 6.3727 1.74087 3.97471 3.09343 1.34281L1.7593 0.657186ZM7.47699 13.091C6.63496 13.9103 4.1884 15.5153 1 15.5153V17.0153C4.65816 17.0153 7.46324 15.1972 8.52301 14.1661L7.47699 13.091ZM19.0005 1.83982C18.0899 0.861517 16.7767 0.25 15.3223 0.25V1.75C16.35 1.75 17.2687 2.18081 17.9025 2.86181L19.0005 1.83982ZM18.5607 3.09283C19.6503 2.93252 20.7168 2.37623 21.5194 1.5096L20.4189 0.4904C19.8435 1.11164 19.0859 1.4994 18.3423 1.6088L18.5607 3.09283ZM0.591869 16.8945C2.89228 18.3866 5.10563 18.75 7.5 18.75V17.25C5.28463 17.25 3.38682 16.9195 1.40813 15.6361L0.591869 16.8945Z" fill="#070707"/>
                                                </svg>
                                            </span>
                                            <TextField
                                                formData={formData.socialMedia}
                                                formKey='twitter'
                                                onDataChange={onSocialMediaChange}
                                                placeholder='Enter Twitter URL'
                                                isRequired={false}
                                                formValidator={formValidator}
                                                validation='twitter_url'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-20">
                                        <div className="social-general">
                                            <span>
                                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6 8.5V16.5M16 16.5V12.5C16 10.567 14.433 9 12.5 9C10.567 9 9 10.567 9 12.5V16.5V8.5M5.5 6H6.5M2 1H20C20.5523 1 21 1.44772 21 2V20C21 20.5523 20.5523 21 20 21H2C1.44772 21 1 20.5523 1 20V2C1 1.44772 1.44772 1 2 1Z" stroke="#070707" stroke-width="1.5"/>
                                                </svg>
                                            </span>
                                            <TextField
                                                formData={formData.socialMedia}
                                                formKey='linkedIn'
                                                onDataChange={onSocialMediaChange}
                                                placeholder='Enter LinkedIn URL'
                                                isRequired={false}
                                                formValidator={formValidator}
                                                validation='linkedin_url'
                                            />
                                        </div>
                                    </div>
                                    {
                                        formData.socialMedia.hasOwnProperty("instagram") &&
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-20">
                                            <div className="social-general forminpt mb-0">
                                                <span>
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 6H17.5M5 1H17C19.2091 1 21 2.79086 21 5V17C21 19.2091 19.2091 21 17 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1ZM11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                                </span>
                                                <TextField
                                                    formData={formData.socialMedia}
                                                    formKey='instagram'
                                                    onDataChange={onSocialMediaChange}
                                                    placeholder='Enter Instagram URL'
                                                    isRequired={false}
                                                    formValidator={formValidator}
                                                    validation='instagram_url'
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                        formData.socialMedia.hasOwnProperty("facebook") &&
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 mb-20">
                                            <div className="social-general forminpt mb-0">
                                                <span>
                                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5ZM11.5 21.5V9.5C11.5 8.39543 12.3954 7.5 13.5 7.5H15M8 13.5H15" stroke="#070707" stroke-width="1.5"/> </svg>
                                                </span>
                                                <TextField
                                                    formData={formData.socialMedia}
                                                    formKey='facebook'
                                                    onDataChange={onSocialMediaChange}
                                                    placeholder='Enter Facebook URL'
                                                    isRequired={false}
                                                    formValidator={formValidator}
                                                    validation='facebook_url'
                                                />
                                            </div>
                                        </div>
                                    }
                                    {
                                        formData.socialMedia && formData.socialMedia.other.length > 0 &&
                                        formData.socialMedia.other.map((el, index) => {
                                            console.log("formData.socialMedia.other>",formData.socialMedia.other);
                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-11 mb-20">
                                                        <div className="social-general forminpt socialmarge mb-0">
                                                            <span>
                                                            <img src={noImg} />
                                                            </span>
                                                            <TextField
                                                                formData={formData.socialMedia.other}
                                                                formKey='url'
                                                                onDataChange={(event) => onOtherMediaChange(event, index)}
                                                                placeholder='Enter URL'
                                                                isRequired={false}
                                                                urlErrors={otherLinksError}
                                                                showUrlErrors={showOtherLinkError}
                                                                // formValidator={formValidator}
                                                                // validation='otherUrl'
                                                                index={index}
                                                            />
                                                            <span className="trashIcon">
                                                            <a onClick={() => deleteOtherURL(index)} href="javascript:void(0)">
                                                                <img src={deleteImg} width="20" />
                                                            </a>
                                                        </span>
                                                        </div>
                                                    </div>
                                                    
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                        <div className="load-more mt-10">
                                            <a href='javascript:void(0)' onClick={openModalTwoMore} className="viewwLink" data-target='inventoryMore'>+ Add More</a>
                                        </div>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-xs-12 pl-0 mt-30">
                                        <div className="forminpt fR">
                                            <a onClick={onSubmitClick} href="javascript:void(0);" className="btn btn-orange brand-btn">Next</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div id="social-links" className={`popup ${showModalTwoMore === false ? "hide" : ""}`}>
                <div className="popup-header">
                    <h3 className="htx2 pophead">Add more Social Medial Links</h3>
                    <span className="close toggle" onClick={closeWithoutSaving} data-target="myPopup">close</span> 
                </div>
                <div className="popup-body">
                    <div className="social-links-popup">
                        <ul>
                            {
                                formData?.socialMedia && !formData?.socialMedia.hasOwnProperty("instagram") &&
                                <li onClick={() => addNewSocialLink("instagram")}>
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5 6H17.5M5 1H17C19.2091 1 21 2.79086 21 5V17C21 19.2091 19.2091 21 17 21H5C2.79086 21 1 19.2091 1 17V5C1 2.79086 2.79086 1 5 1ZM11 15C8.79086 15 7 13.2091 7 11C7 8.79086 8.79086 7 11 7C13.2091 7 15 8.79086 15 11C15 13.2091 13.2091 15 11 15Z" stroke="#070707" stroke-width="1.5"/> </svg>
                                </li>
                            }
                            {
                                formData?.socialMedia && !formData?.socialMedia.hasOwnProperty("facebook") &&
                                <li onClick={() => addNewSocialLink("facebook")}>
                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.5 21.5C5.97715 21.5 1.5 17.0228 1.5 11.5C1.5 5.97715 5.97715 1.5 11.5 1.5C17.0228 1.5 21.5 5.97715 21.5 11.5C21.5 17.0228 17.0228 21.5 11.5 21.5ZM11.5 21.5V9.5C11.5 8.39543 12.3954 7.5 13.5 7.5H15M8 13.5H15" stroke="#070707" stroke-width="1.5"/> </svg>
                                </li>
                            }
                            <li onClick={() => addNewSocialLink("")} className="add-social"><a href="javascript:void(0);"><img src={plusIcon}/></a></li>
                        </ul>
                        <div className="clearfix mt-10"></div>
                        {/* <a href="javascript:void(0);" className="btn btn-orange brand-btn">ADD</a> */}
                    </div>
                </div>
            </div>

            <ConfirmAlert
                when={showPrompt}
                title="Leave page without saving..."
                cancelText="Cancel"
                okText="Confirm"
                onOK={() => true}
                onCancel={() => false}
                parentCallback={confirmAlertCallback}
            />
            <ConfirmDialog
                confirmTitle="Poor Internet Connection Detected"
                componentName="We've detected issues with your internet connection that could affect brand onboarding & data loss. Please check your internet connection"
                confirmText="Got it"
                denyText="Cancel" 
                togglePopup={toggleNetworkDialog}
                onModalClose={networkConfirmClose}
                onConfirmBtn={true}
            />
        </>
    )
}

export default ProfileGeneral
